package com.exura.features.userprofile.di

import com.exura.features.userprofile.data.repository.BaseProviderProfileRepositoryImpl
import com.exura.features.userprofile.data.repository.ProviderProfileRepositoryImpl
import com.exura.features.userprofile.domain.repository.BaseProviderProfileRepository
import com.exura.features.userprofile.domain.repository.ProviderProfileRepository
import com.exura.features.userprofile.domain.usecase.GetProviderProfileUseCase
import com.exura.features.userprofile.domain.usecase.SaveProviderProfileUseCase
import org.koin.dsl.module

val providerProfileModule = module {
    single<BaseProviderProfileRepository> {
        BaseProviderProfileRepositoryImpl(
            firestore = get(),
        )
    }

    single<ProviderProfileRepository> {
        ProviderProfileRepositoryImpl(
            baseRepository = get(),
            getUserDataPrefixUseCase = get(),
        )
    }

    factory { GetProviderProfileUseCase(get(), get()) }
    factory { SaveProviderProfileUseCase(get()) }

}
